<template>
  <div>
    <div class="map-title">Distribución geografica</div>
    <div class="map-subtitle">de la variable seleccionada</div>
    <v-chart id="map-chart" :options="graph"/>
  </div>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/map/js/world'

export default {
  name: 'region-map',
  components: {'v-chart': ECharts},
  props: ['data'],
  data() {
    return {
      ready: false,
      graph: {
        grid: {
          top: 160,
          bottom: 0,
        },
        tooltip: {
          formatter:  function (params) {
            if (params.data)
              return '<strong>'+params.data.name[0]+'</strong><br>'+params.data.name[1]+'<br>'+params.data.name[2]+'<br>'+params.data.name[3]+'<br>'+params.data.name[4]+'<br>'+params.data.name[5]
          },
          position: 'right'
        },
        textStyle: {
          fontFamily: 'Gotham-Book, Arial',
          color: '#888'
        },
        series: [
          {
            name: 'argentina',
            type: 'map',
            top:160,
            layoutSize: 100,
            itemStyle: {
              emphasis: {
                areaColor: null
              }
            },
            map: 'world',
            zoom: 22,
            center: [-64, -32],
            hoverAnimation: false,
            markPoint: {
              symbol: 'circle',
              symbolSize: 42,
              itemStyle: {
                color: '#47A44A',
              },
              label: {
                show: true,
                position: 'inside',
                color: '#FFF',
              },
              data: this.data
            }
          },
        ]
      }
    }
  },
  mounted() {
    if (window.screen.width < 600) {
      this.graph.series[0].zoom = 20;
      this.graph.tooltip.position = 'inside'
    }
  }
}

</script>

<style>
  .map-title{
    font-family: Gotham-Book;
    font-size: 18px;
    color: '#5E5E5E';
    display: none;
  }
  .map-subtitle{
    font-family: Gotham-Book;
    font-size: 14px;
    line-height: 1.3em;
    color: '#777';
    display: none;
  }
  #map-chart.echarts { width: 100%; height: 450px; }
  @media only screen and (max-width: 600px) {
    .map-title{
      display: block;
    }
    .map-subtitle{
      display: block;
    }
  }

</style>

